export const FINANCE_IFRAME_HEIGHT: number = 1550
